import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

// Import routing
import { AppRoutingModule } from './app-routing.module';

// Import components
import { AppComponent } from './app.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { HotelComponent } from './modules/hotel/hotel.component';
import { OfficeLeaseComponent } from './modules/office-lease/office-lease.component';
import { GolfComponent } from './modules/golf/golf.component';
import { SalesActivitiesComponent } from './modules/sales-activities/sales-activities.component';
import { LoginComponent } from './modules/login/login.component';

// Import modules
import { DefaultLayoutModule } from './shared/components/default-layout/default-layout.module';
import { ToastrComponent } from './core/toastr/toastr.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalComponent } from './core/modal/modal.component';
import { TableComponent } from './core/table/table.component';
import { RupiahPipe } from './core/rupiah/rupiah.pipe';
import { NgApexchartsModule } from "ng-apexcharts";
import { SidebarService } from './shared/components/default-layout/sidebar/sidebar.service';
import { EventsActivitiesComponent } from './modules/events-activities/events-activities.component';
import { ResidencesComponent } from './modules/residences/residences.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PieChartComponent } from './core/pie-chart/pie-chart.component';
import { DateRangePickerComponent } from './core/date-range-picker/date-range-picker.component';
import { HeaderComponent } from './shared/components/default-layout/header/header.component';
import { SharedModule } from './shared/share.module';
import { UserprofileComponent } from './modules/userprofile/userprofile.component';
import { ModalSignOutComponent } from './core/modal-sign-out/modal-sign-out.component';
import { ModalChangePasswordComponent } from './core/modal-change-password/modal-change-password.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Server404Component } from './modules/server-404/server-404.component';
import { Server500Component } from './modules/server-500/server-500.component';
import { SalesActivitiesDetailComponent } from './modules/sales-activities-detail/sales-activities-detail.component';
import { ProgressStepBarComponent } from './core/progress-step-bar/progress-step-bar.component';
import { DateformatPipe } from './core/dateformat.pipe';
import { TenantListComponent } from './modules/tenant-list/tenant-list.component';
import { HotelDetailComponent } from './modules/hotel-detail/hotel-detail.component';
import { OfficeLeaseDetailComponent } from './modules/office-lease-detail/office-lease-detail.component';
import { ResidencesDetailComponent } from './modules/residences-detail/residences-detail.component';
import { TenantBusinessDetailComponent } from './modules/tenant-business-detail/tenant-business-detail.component';
import { SquareMeterPipe } from './core/square-meter/square-meter.pipe';
import { ImagePathPipe } from './core/image-path/image-path.pipe';
import { TenantModalComponent } from './core/tenant-modal/tenant-modal.component';
import { BuildingModalComponent } from './core/building-modal/building-modal.component'; //TW20251010
import { LimitTextPipe } from './core/limit-text/limit-text.pipe';
import { ThousandSeparatorPipe } from './core/thousand-separator/thousand-separator.pipe';
import { PhoneFormatPipe } from './core/phone-format/phone-format.pipe';
import { ModalIncompleteComponent } from './core/modal-incomplete/modal-incomplete.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SalesListComponent } from './modules/sales-list/sales-list.component';
import { SalesListDetailComponent } from './modules/sales-list-detail/sales-list-detail.component';
import { RecaptchaModule, RecaptchaFormsModule, RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from '../environments/environment.development';


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    HotelComponent,
    OfficeLeaseComponent,
    GolfComponent,
    SalesActivitiesComponent,
    LoginComponent,
    ToastrComponent,
    ModalComponent,
    TableComponent,
    RupiahPipe,
    EventsActivitiesComponent,
    ResidencesComponent,
    PieChartComponent,
    UserprofileComponent,
    ModalSignOutComponent,
    ModalChangePasswordComponent,
    Server404Component,
    Server500Component,
    SalesActivitiesDetailComponent,
    ProgressStepBarComponent,
    DateformatPipe,
    TenantListComponent,
    HotelDetailComponent,
    OfficeLeaseDetailComponent,
    ResidencesDetailComponent,
    TenantBusinessDetailComponent,
    SquareMeterPipe,
    ImagePathPipe,
    TenantModalComponent,
    BuildingModalComponent, //TW20251010
    LimitTextPipe,
    ThousandSeparatorPipe,
    PhoneFormatPipe,
    ModalIncompleteComponent,
    SalesListComponent,
    SalesListDetailComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    HttpClientModule,
    DefaultLayoutModule,
    RouterModule,
    BrowserAnimationsModule,
    NgApexchartsModule,
    NgbTooltipModule,
    SharedModule,
    NgxSpinnerModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 1 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:1000'
    }),

    RecaptchaModule,
    RecaptchaFormsModule,
    RecaptchaV3Module
  ],
  providers: [
    SidebarService,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaSiteKey 
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
